<template>
  <section class="apply-form">    
    <div class="wrapper">
      <h2>Apply Now</h2>
      <div class="form-description" v-if="false">
          <h2 class="underline-light">Apply for this job</h2>
          <div class="informative-text">Your full LinkedIn profile will be shared. <a href="#"> Learn More </a></div> <a class="linkedin-btn" href="#">Apply with Linkedin</a>
      </div>
      <div class="form" >
          <div class="note">Fields with <span class="asterisk">*</span> are required</div>
          <form id="apply-form" @submit.prevent="checkForm" novalidate>
              <div class="form-group">
                  <label for="first_name">First Name <span class="asterisk">*</span></label>
                  <input id="first_name" v-model="data.first_name" type="text" :class="{ 'has-error':this.field_errors.first_name.length }" required>
                  <p class="field-error-msg" v-for="error in this.field_errors.first_name" :key="error">{{ error }}</p>
              </div>
              <div class="form-group">
                  <label for="last_name">Last Name <span class="asterisk">*</span></label>
                  <input id="last_name" v-model="data.last_name" name="last_name" type="text" :class="{ 'has-error':this.field_errors.last_name.length }" required>
                  <p class="field-error-msg" v-for="error in this.field_errors.last_name" :key="error">{{ error }}</p>
              </div>
              <div class="form-group">
                  <label for="email">Email Address <span class="asterisk">*</span></label>
                  <input id="email" v-model="data.email" name="email" type="text" :class="{ 'has-error':this.field_errors.email.length }" required>
                  <p class="field-error-msg" v-for="error in this.field_errors.email" :key="error">{{ error }}</p>
              </div>
              <div class="form-group">
                  <label for="phone_number">Phone Number</label>
                  <input id="phone_number" v-model="data.phone" name="phone_number" :class="{ 'has-error':this.field_errors.phone.length }" type="text">
                  <p class="field-error-msg" v-for="error in this.field_errors.phone" :key="error">{{ error }}</p>
              </div>
              <div class="form-group w-100">
                  
                  <label for="file">Upload your resume <span class="asterisk">*</span></label>
                  <div class="upload-file">
                      <span  :class="{ 'has-error':this.field_errors.file.length, 'custom-upload-input': true }" >Choose a file</span>
                      <input id="resume" name="file" type="file" ref="file" required v-on:change="handleFileUpload($event)">
                      <p class="field-error-msg" v-for="error in this.field_errors.file" :key="error">{{ error }}</p>
                  </div>
              </div>
              <div class="form-group w-100">
                  <input class="btn outline" type="submit" :disabled="posting" value="Submit">
                  <div class="loading" v-show="this.posting">
                    <img width="60" height="60" :src="loading_image_url" />
                  </div>
              </div>
          </form>
          <p class="has-errors" v-if="this.errors.length">
            <b>Please correct the following error(s):</b>
            <ul>
              <li v-for="error in errors" :key="error">{{ error }}</li>
            </ul>
          </p>
          <p class="success-submit" v-if="this.submited">
            <b>Your application has been received.</b>
          </p>
      </div>
    </div>
  </section>
</template>

<script>
  import axios from 'axios'

  export default {
    name: "JobForm",
    data () {
      return {
        posting: false,    
        submited: false,    
        data:{
          first_name: '',
          last_name: '',
          email: '',
          phone: '',
        },
        file: '',
        field_errors: {
          'first_name': [],
          'last_name': [],
          'email': [],
          'phone': [],
          'file': []
        },
        errors: []
      }
    },
    props: ['wpLever','job_id'],
    methods: {
      postJob () {        
        this.posting = true
        let params = new FormData()
        for ( var key in this.data ) {
            params.append(key, this.data[key]);
        }
        params.append('job_id', this.job_id)
        params.append('file', this.file);
        params.append('action', 'postings_action')
        params.append('nonce', wpLever.nonce) // eslint-disable-line 
        axios
          .post(
            wpLever.ajaxurl, // eslint-disable-line
            params,
            {
              headers: {
                  'Content-Type': 'multipart/form-data'
              }
            }
          ) 
          .then(response => {
            this.posting = false
            if( response.data.success === false) {
              this.errors = response.data.errors
            }else{
              this.submited = true
              this.clearForm()
            }
          })
          .catch((error) => {
            if( error.response ){
                this.errors = [error.response.data]; // => the response payload 
            }
          })
      },
      checkForm: function () {
        this.errors = [];
        this.field_errors.first_name = [];
        this.field_errors.last_name = [];
        this.field_errors.email = [];
        this.field_errors.phone = [];
        this.field_errors.file = [];


        let hasErrors = false
        if (!this.data.first_name) {
          hasErrors = true
          this.field_errors.first_name.push('First Name is required.');
        }
        if (!this.data.last_name) {
          hasErrors = true
          this.field_errors.last_name.push('Last Name is required.');
        }

        if (!this.data.email) {
          hasErrors = true
          this.field_errors.email.push('Email Address is required.');
        }

        if (!this.file) {
          hasErrors = true
          this.field_errors.file.push('Resume is required.');
        }

        if (!this.validateEmail() && this.data.email) {
          hasErrors = true
          this.field_errors.email.push('Invalid Email Address format.');
        }

        if (!this.validatePhone() && this.data.phone) {
          hasErrors = true
          this.field_errors.phone.push('Invalid Phone Number format.');
        }

        if (!this.validateFile() && this.file) {
          hasErrors = true
          this.field_errors.file.push('Invalid file format (pdf, docx, doc, txt).');
        }

        if( !hasErrors ) {
          this.postJob()
        }
      },
      clearForm: function () {
        this.submited = true
        this.data.first_name = ''
        this.data.last_name = ''
        this.data.email = ''
        this.data.phone = ''
        console.log(this.$refs)
        this.$refs.file.value = null
      },
      validateEmail() {          
          const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return re.test(String(this.data.email).toLowerCase())
      },
      validatePhone() {
        return !isNaN(this.data.phone);
      },
      validateFile(){        
        const re = /(\.pdf|\.doc|\.docx|\.txt)$/i;
        return re.test(this.file.name) 
      },
      handleFileUpload(event){ 
        this.file = event.target.files[0];        
      }      
    },
    created () {
      this.loading_image_url = wpLever.loading_image_url // eslint-disable-line
    }
  }
</script>